import { useState } from 'react';

export default function GlobalRankings() {
  const [timeFilter, setTimeFilter] = useState('all-time');

  const topPlayers = [
    {
      rank: 1,
      name: 'ShadowStrike',
      country: 'USA',
      flag: '🇺🇸',
      points: 15847,
      wins: 892,
      losses: 143,
      winRate: 86.2,
      avatar: 'https://public.readdy.ai/ai/img_res/3f284f296e27f126b227decaede17684.jpg',
      trend: 'up',
      change: 3
    },
    {
      rank: 2,
      name: 'PhantomEdge',
      country: 'South Korea',
      flag: '🇰🇷',
      points: 15234,
      wins: 856,
      losses: 167,
      winRate: 83.7,
      avatar: 'https://readdy.ai/api/search-image?query=Elite%20esports%20player%20avatar%20with%20gaming%20gear%20and%20purple%20lighting%20effects%2C%20professional%20competitive%20gamer%20profile%20photo%20with%20intense%20focus%20and%20determination%2C%20championship%20player%20portrait&width=200&height=200&seq=player-2&orientation=squarish',
      trend: 'up',
      change: 1
    },
    {
      rank: 3,
      name: 'RevenantKing',
      country: 'Brazil',
      flag: '🇧🇷',
      points: 14892,
      wins: 823,
      losses: 189,
      winRate: 81.3,
      avatar: 'https://readdy.ai/api/search-image?query=Top%20tier%20gaming%20champion%20avatar%20with%20purple%20and%20gold%20accents%2C%20professional%20esports%20player%20profile%20picture%20with%20victory%20pose%20and%20confident%20smile%2C%20competitive%20gaming%20portrait&width=200&height=200&seq=player-3&orientation=squarish',
      trend: 'down',
      change: 1
    },
    {
      rank: 4,
      name: 'BladeRunner',
      country: 'Japan',
      flag: '🇯🇵',
      points: 14567,
      wins: 798,
      losses: 201,
      winRate: 79.9,
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20gaming%20player%20avatar%20with%20sleek%20gaming%20setup%20and%20purple%20neon%20lighting%2C%20competitive%20esports%20athlete%20profile%20photo%20with%20focused%20expression%2C%20modern%20gamer%20portrait&width=200&height=200&seq=player-4&orientation=squarish',
      trend: 'up',
      change: 2
    },
    {
      rank: 5,
      name: 'MindReader',
      country: 'Sweden',
      flag: '🇸🇪',
      points: 14123,
      wins: 765,
      losses: 218,
      winRate: 77.8,
      avatar: 'https://readdy.ai/api/search-image?query=Skilled%20esports%20competitor%20avatar%20with%20gaming%20headphones%20and%20purple%20ambient%20lighting%2C%20professional%20player%20profile%20picture%20with%20strategic%20thinking%20expression%2C%20competitive%20gaming%20portrait&width=200&height=200&seq=player-5&orientation=squarish',
      trend: 'same',
      change: 0
    },
    {
      rank: 6,
      name: 'StyleMaster',
      country: 'Canada',
      flag: '🇨🇦',
      points: 13856,
      wins: 742,
      losses: 234,
      winRate: 76.0,
      avatar: 'https://readdy.ai/api/search-image?query=Creative%20gaming%20champion%20avatar%20with%20stylish%20gaming%20gear%20and%20purple%20lighting%2C%20professional%20esports%20player%20profile%20with%20confident%20attitude%20and%20modern%20aesthetic%2C%20competitive%20gamer%20portrait&width=200&height=200&seq=player-6&orientation=squarish',
      trend: 'up',
      change: 1
    },
    {
      rank: 7,
      name: 'ThunderStrike',
      country: 'Germany',
      flag: '🇩🇪',
      points: 13492,
      wins: 718,
      losses: 256,
      winRate: 73.7,
      avatar: 'https://readdy.ai/api/search-image?query=Powerful%20esports%20player%20avatar%20with%20gaming%20equipment%20and%20purple%20electric%20effects%2C%20professional%20competitive%20gamer%20profile%20picture%20with%20intense%20determination%2C%20championship%20player%20portrait&width=200&height=200&seq=player-7&orientation=squarish',
      trend: 'down',
      change: 2
    },
    {
      rank: 8,
      name: 'NightHawk',
      country: 'UK',
      flag: '🇬🇧',
      points: 13178,
      wins: 695,
      losses: 278,
      winRate: 71.4,
      avatar: 'https://readdy.ai/api/search-image?query=Strategic%20esports%20competitor%20avatar%20with%20gaming%20headset%20and%20purple%20dark%20lighting%2C%20professional%20player%20profile%20photo%20with%20tactical%20mindset%20and%20focus%2C%20competitive%20gaming%20portrait&width=200&height=200&seq=player-8&orientation=squarish',
      trend: 'up',
      change: 3
    },
    {
      rank: 9,
      name: 'VortexGaming',
      country: 'France',
      flag: '🇫🇷',
      points: 12934,
      wins: 672,
      losses: 289,
      winRate: 69.9,
      avatar: 'https://readdy.ai/api/search-image?query=Dynamic%20esports%20player%20avatar%20with%20modern%20gaming%20setup%20and%20purple%20swirl%20effects%2C%20professional%20competitive%20gamer%20profile%20picture%20with%20energetic%20expression%2C%20championship%20player%20portrait&width=200&height=200&seq=player-9&orientation=squarish',
      trend: 'same',
      change: 0
    },
    {
      rank: 10,
      name: 'CrimsonFury',
      country: 'Australia',
      flag: '🇦🇺',
      points: 12567,
      wins: 648,
      losses: 312,
      winRate: 67.5,
      avatar: 'https://readdy.ai/api/search-image?query=Fierce%20esports%20champion%20avatar%20with%20gaming%20gear%20and%20purple%20red%20lighting%20effects%2C%20professional%20player%20profile%20photo%20with%20aggressive%20competitive%20spirit%2C%20modern%20gamer%20portrait&width=200&height=200&seq=player-10&orientation=squarish',
      trend: 'down',
      change: 1
    }
  ];

  const timeFilters = [
    { id: 'all-time', label: 'All Time' },
    { id: 'season', label: 'This Season' },
    { id: 'month', label: 'This Month' },
    { id: 'week', label: 'This Week' }
  ];

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-between mb-12">
          <div>
            <h2 className="text-4xl font-bold text-white mb-3">Top Players</h2>
            <p className="text-gray-400">The best of the best in Brawlhalla competitive scene</p>
          </div>
          
          <div className="flex gap-2 mt-4 md:mt-0">
            {timeFilters.map(filter => (
              <button
                key={filter.id}
                onClick={() => setTimeFilter(filter.id)}
                className={`px-4 py-2 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  timeFilter === filter.id
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-gray-800 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-900">
                <tr>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">Rank</th>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">Player</th>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">Points</th>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">W/L</th>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">Win Rate</th>
                  <th className="px-6 py-4 text-left text-gray-400 font-semibold">Trend</th>
                </tr>
              </thead>
              <tbody>
                {topPlayers.map((player, index) => (
                  <tr 
                    key={player.rank}
                    className={`border-t border-gray-700 hover:bg-gray-750 transition-colors cursor-pointer ${
                      index < 3 ? 'bg-purple-900/10' : ''
                    }`}
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        {player.rank <= 3 ? (
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                            player.rank === 1 ? 'bg-yellow-500 text-gray-900' :
                            player.rank === 2 ? 'bg-gray-400 text-gray-900' :
                            'bg-orange-600 text-white'
                          }`}>
                            {player.rank}
                          </div>
                        ) : (
                          <span className="text-gray-400 font-semibold text-lg">#{player.rank}</span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center space-x-4">
                        <img 
                          src={player.avatar}
                          alt={player.name}
                          className="w-12 h-12 rounded-full object-cover object-top"
                        />
                        <div>
                          <div className="text-white font-semibold">{player.name}</div>
                          <div className="text-gray-400 text-sm">
                            <span className="mr-2">{player.flag}</span>
                            {player.country}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-purple-400 font-bold text-lg">
                        {player.points.toLocaleString()}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-white">
                        <span className="text-green-400 font-semibold">{player.wins}</span>
                        <span className="text-gray-500 mx-1">/</span>
                        <span className="text-red-400 font-semibold">{player.losses}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="w-24 bg-gray-700 rounded-full h-2 mr-3">
                          <div 
                            className="bg-purple-500 h-2 rounded-full"
                            style={{ width: `${player.winRate}%` }}
                          ></div>
                        </div>
                        <span className="text-white font-semibold">{player.winRate}%</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        {player.trend === 'up' && (
                          <div className="flex items-center text-green-400">
                            <i className="ri-arrow-up-line text-xl"></i>
                            <span className="font-semibold ml-1">{player.change}</span>
                          </div>
                        )}
                        {player.trend === 'down' && (
                          <div className="flex items-center text-red-400">
                            <i className="ri-arrow-down-line text-xl"></i>
                            <span className="font-semibold ml-1">{player.change}</span>
                          </div>
                        )}
                        {player.trend === 'same' && (
                          <div className="flex items-center text-gray-400">
                            <i className="ri-subtract-line text-xl"></i>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <button className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
            View Full Rankings
          </button>
        </div>
      </div>
    </section>
  );
}
